import { render, staticRenderFns } from "./AddOferta.vue?vue&type=template&id=464573fe&scoped=true"
import script from "./AddOferta.vue?vue&type=script&lang=js"
export * from "./AddOferta.vue?vue&type=script&lang=js"
import style0 from "./AddOferta.vue?vue&type=style&index=0&id=464573fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464573fe",
  null
  
)

export default component.exports